import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';
import { ScrollTag, SCROLL_TAG_KEY } from '../useScrollToTag';

export const getCheckInRedirectRoute = (
  roomSlug: string | null | undefined,
): string | undefined => {
  return roomSlug !== undefined && roomSlug !== null && roomSlug !== ''
    ? `/v2/check-in/${roomSlug}`
    : undefined;
};

export const getSettingsPreferencesSelfPreviewVideoRoute = (): string => {
  return `${
    getPublicRuntimeConfig().paths.preferencesSettings
  }?${SCROLL_TAG_KEY}=${ScrollTag.SelfPreviewVideo}`;
};
